// fileSlug is the stem of the downloaded PDF's filename. Declared per type rather than
// derived from the type string, so a type that isn't a commissioning report doesn't have to
// be named `commissioning-*` to get a sensible filename.
export const COMMISSIONING_TYPES = [
  { value: 'commissioning-comm-loop-v2', labelKey: 'commissioning.commLoop', deviceType: 'commLoop', fileSlug: 'comm-loop-v2-commissioning-report' },
  { value: 'commissioning-circuit', labelKey: 'commissioning.circuit', deviceType: 'circuit', fileSlug: 'circuit-commissioning-report' },
  { value: 'commissioning-controller', labelKey: 'commissioning.controller', deviceType: 'controller', fileSlug: 'controller-commissioning-report' },
  { value: 'commissioning-cable-pre-insulation', labelKey: 'commissioning.cablePreInsulation', deviceType: 'circuit', fileSlug: 'cable-pre-insulation-commissioning-report' },
  { value: 'commissioning-cable-post-insulation', labelKey: 'commissioning.cablePostInsulation', deviceType: 'circuit', fileSlug: 'cable-post-insulation-commissioning-report' },
  { value: 'audit-hms', labelKey: 'hmsAudit.modalTitle', deviceType: 'controller', fileSlug: 'hms-audit-report' },
  { value: 'audit-eht-insulation', labelKey: 'ehtInsulationAudit.modalTitle', deviceType: 'controller', fileSlug: 'eht-insulation-audit-report' },
  { value: 'audit-panel', labelKey: 'panelAudit.modalTitle', deviceType: 'controller', fileSlug: 'panel-audit-report' },
  { value: 'audit-eht-circuit', labelKey: 'ehtCircuitAudit.modalTitle', deviceType: 'circuit', fileSlug: 'eht-circuit-audit-report' },
];

export const COMMISSIONING_FILE_SLUG_MAP: Record<string, string> = {
  ...Object.fromEntries(COMMISSIONING_TYPES.map(({ value, fileSlug }) => [value, fileSlug])),
  // Absent from COMMISSIONING_TYPES above so it stays off the list screen, but still
  // downloadable from device pages.
  'commissioning-comm-loop': 'comm-loop-commissioning-report',
};

export const COMMISSIONING_DEVICE_TYPE_MAP: Record<string, string> = Object.fromEntries(
  COMMISSIONING_TYPES.map(({ value, deviceType }) => [value, deviceType])
);

export const COMMISSIONING_TYPE_LABEL_MAP: Record<string, string> = Object.fromEntries(
  COMMISSIONING_TYPES.map(({ value, labelKey }) => [value, labelKey])
);

export const COMMISSIONING_STATUS_OPTIONS = [
  { value: 'pass', labelKey: 'common.pass' },
  { value: 'pass-with-notes', labelKey: 'common.passWithNotes' },
  { value: 'failed', labelKey: 'common.fail' },
];
